import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/o/login',
            component: resolve => require(['pages/Login'], resolve),
        },
        {
            path: '/',
            component: resolve => require(['components/Layout'], resolve),
            redirect: '/cs/index',
            children: [
                {
                    path: '/cs/index',
                    component: resolve => require(['pages/Index'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                // 信息
                //  试剂柜信息
                {
                    path: '/cs/cabinetManage',
                    component: resolve => require(['pages/Permission/CabinetManage'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    台账信息
                {
                    path: '/cs/ParameterInformation',
                    component: resolve => require(['pages/Permission/ParameterInformation'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    台账表格查看
                {
                    path: '/cs/parameterInformation/detail/:storageNo',
                    component: resolve => require(['pages/Permission/ParameterInformation/Detail'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    储存信息
                {
                    path: '/cs/StorageMessage',
                    component: resolve => require(['pages/Permission/StorageMessage'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //购买信息
                {
                    path: '/cs/purchaseMessage',
                    component: resolve => require(['pages/Permission/purchaseMessage'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //  管理
                //    手动录入试剂
                {
                    path: '/gs/typingReagents',
                    component: resolve => require(['pages/management/typingReagents'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/gs/excelReagents',
                    component: resolve => require(['pages/management/excelReagents'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    MSDS查询
                {
                    path: '/gs/findMsds',
                    component: resolve => require(['pages/management/findMSDS'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    MSDS详情
                {
                    path: '/gs/msds/info/:chemid',
                    component: resolve => require(['pages/management/findMSDS/Details'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    购置情况employCondition
                {
                    path: '/gs/useCondition',
                    component: resolve => require(['pages/management/useCondition'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    购置情况详细
                {
                    path: '/gs/useCondition/Table/:ORDER_NO',
                    component: resolve => require(['pages/management/useCondition/Table.vue'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    使用情况employCondition
                {
                    path: '/gs/employCondition',
                    component: resolve => require(['pages/management/employCondition'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    使用情况详细
                {
                    path: '/gs/employCondition/table/:chemID/:USER_ID',
                    component: resolve => require(['pages/management/employCondition/Table.vue'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    试剂柜设置
                //    智能秤管理
                {
                    path: '/gs/cabinetSet/smartSaid',
                    component: resolve => require(['pages/management/cabinetSet/smartSaid/index'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    试剂柜管理
                {
                    path: '/gs/cabinetSet/reagentCabinet',
                    component: resolve => require(['pages/management/cabinetSet/reagentCabinet'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    试剂柜管理人员页面
                {
                    path: '/gs/cabinetSet/reagentCabinet/People/:CABINET_ID/:EQUIP_ID',
                    component: resolve => require(['pages/management/cabinetSet/reagentCabinet/People'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    实验室管理
                {
                    path: '/gs/laboratory/management',
                    component: resolve => require(['pages/management/laboratory/laboratoryManagement'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    实验室房间
                {
                    path: '/gs/laboratory/management',
                    component: resolve => require(['pages/management/laboratory/laboratoryManagement'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    实验室房间
                {
                    path: '/gs/laboratory/LaboratoryRoom',
                    component: resolve => require(['pages/management/laboratory/laboratoryRoom'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                //    实验室人员
                {
                    path: '/gs/laboratory/LaboratoryStaff',
                    component: resolve => require(['pages/management/laboratory/LaboratoryPeople'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        if (localStorage.Labtoken && sessionStorage.Labtoken) {
            next();
        } else {
            next({
                path: '/o/login',
                query: { redirect: to.fullPath },
            });
        }
    } else {
        next();
    }
});
export default router;
